const getRuntimeFeatureValues = (publicRuntimeConfig) => {
  const enabledFeatures = publicRuntimeConfig?.grandvision?.features ?? [];
  const myAccount = isFeatureEnabled(enabledFeatures, "MYACCOUNT");
  return { myAccount };
};
const isFeatureEnabled = (enabledFeatures, feature) => {
  return enabledFeatures.includes(feature);
};
export {
  getRuntimeFeatureValues
};
//# sourceMappingURL=get-runtime-feature-values.js.map
